import { Field } from 'react-final-form';
import { useIntl } from 'react-intl';
import { FileUploadField } from '@unite-us/app-components';

const CustomFileUploadField = ({
  name,
  label,
  id,
  required,
  onFileSelect,
  onFileRemove,
  multiple = false,
  fileStatuses = [],
  ...rest
}) => {
  const intl = useIntl();

  return (
    <Field name={name}>
      {(fieldProps) => {
        const { input, meta } = fieldProps;


        const handleFileChange = (files) => {
          let filesToProcess;

          if (Array.isArray(files)) {
            filesToProcess = files.filter(file => file != null);
          } else if (files) {
            filesToProcess = [files];
          } else {
            filesToProcess = [];
          }

          const result = multiple ? filesToProcess : (filesToProcess[0] || null);
          input.onChange(result);

          if (onFileSelect) {
            onFileSelect(filesToProcess);
          }
        };

        const handleRemove = async (tempId) => {
          if (onFileRemove && tempId) {
            await onFileRemove(tempId);
          }
        };

        return (
          <FileUploadField
            label={label}
            id={id}
            required={required}
            multiple={multiple}
            {...rest}
            {...fieldProps}
            input={input}
            onFilesChange={handleFileChange}
            showPreviewBelow
            fileStatuses={fileStatuses}
            onRemove={handleRemove}
          />
        );
      }}
    </Field>
  );
};

export default CustomFileUploadField;

